import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAdminUsers, deleteAdminUser } from '../../services/adminManagementServices';
import { Link } from 'react-router-dom';
import { AppDispatch } from '../../core/data/redux/store';
import * as Icon from 'react-feather';
import { Breadcrumb, Card, Button, Table, Tag, Modal, Space, Typography, message } from 'antd';

const { Title } = Typography;

const ListAdmins = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { adminUsers, isLoading, isError, errorMessage } = useSelector((state: any) => state.adminManagement);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState<any>(null);

  useEffect(() => {
    dispatch(getAllAdminUsers());
  }, [dispatch]);

  const handleDelete = (admin: any) => {
    setSelectedAdmin(admin);
    setDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (selectedAdmin) {
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken) {
        dispatch(deleteAdminUser(accessToken, selectedAdmin.id, setDeleteModalOpen));
        message.success('Admin deleted successfully');
      }
    }
  };

  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Full Name',
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: 'Email',
      dataIndex: 'email_address',
      key: 'email_address',
    },
    {
      title: 'Phone',
      dataIndex: 'phone_number',
      key: 'phone_number',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => (
        <Tag color={role === 'SUPER_ADMIN' ? 'red' : role === 'ADMIN' ? 'gold' : 'blue'}>{role}</Tag>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (is_active: boolean) => (
        <Tag color={is_active ? 'green' : 'red'}>{is_active ? 'Active' : 'Inactive'}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, admin: any) => (
        <Space>
          <Link to={`/admin/admin-management/admin-detail/${admin.id}`}>
            <Button icon={<Icon.Eye size={16} />} size="small" />
          </Link>
          <Link to={`/admin/admin-management/update-admin-role/${admin.id}`}>
            <Button icon={<Icon.Edit size={16} />} size="small" />
          </Link>
          <Button
            icon={<Icon.Trash2 size={16} />} size="small" danger
            onClick={() => handleDelete(admin)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management">Admin Management</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>List Admins</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <Title level={4} style={{ margin: 0 }}>Admin Users</Title>
            <Link to="/admin/admin-management/create-admin">
              <Button type="primary" icon={<Icon.PlusCircle size={16} />}>Add New Admin</Button>
            </Link>
          </div>
          <Table
            columns={columns}
            dataSource={adminUsers}
            loading={isLoading}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
        </Card>
        <Modal
          title="Confirm Delete"
          visible={deleteModalOpen}
          onOk={confirmDelete}
          onCancel={() => setDeleteModalOpen(false)}
          okText="Delete"
          okButtonProps={{ danger: true }}
        >
          <p>Are you sure you want to delete admin <b>{selectedAdmin?.username}</b>?</p>
        </Modal>
      </div>
    </div>
  );
};

export default ListAdmins; 